import React from 'react';
import styles from './ErrorPage.module.scss';
import Placeholder from 'assets/img/no-roles-placeholder.png';
import { useScopedTranslation } from '../../../application/localization/useScopedTranslation.ts';
import clsx from 'clsx';
import { AppLink } from '../../../components/uikit/buttons/AppLink.tsx';
import { Trans } from 'react-i18next';

export const NoRolesErrorPage = () => {
  const i18n = useScopedTranslation('Page.ForbiddenErrorPage');

  return (
    <div className={styles.errorContent}>
      <img src={Placeholder} />
      <div className={styles.errorTitle}>{i18n.t('no_roles_title')}</div>
      <div className={clsx(styles.errorDescription, styles.width580)}>
        <Trans
          i18nKey={'Page.ForbiddenErrorPage.no_roles_description'}
          components={{
            a: (
              <AppLink
                className={styles.link}
                to={'mailto:supportHC@loewensteinmedical.com'}
              />
            ),
          }}
        />
      </div>
    </div>
  );
};
